import { getApiClient } from './ApiClient'

export const mealIngredientListPromise = (params) => {
  return getApiClient()
    .get('/meal-ingredients', {
      params
    })
    .then(resp => {
      return Promise.resolve(resp.data)
    })
}

export const mealIngredientDetailPromise = (id) => {
  return getApiClient()
    .get(`/meal-ingredients/${id}`)
    .then(resp => {
      return Promise.resolve(resp.data)
    })
}

export const mealIngredientUpsertPromise = (body) => {
  return getApiClient()
    .post('/meal-ingredients/upsert', {
      body
    })
    .then(resp => {
      return Promise.resolve(resp.data)
    })
}
